var alignmentStyle = {"alignLeft":"GlJCH","textWrapNowrap":"-ml9E","alignRight":"HWDGK","alignCenter":"T3nLV","sizeFullWidth":"IpSc9","renderedInTable":"iHvb5","sizeOriginal":"bVL2D","sizeContent":"RUGdU","sizeSmall":"_5UgBR","sizeSmallCenter":"_5-EcT","flex":"_48Sve","LEFT":"Rh-qG","CENTER":"tjz5A","RIGHT":"aQtNk","AUTO":"RKsdM","JUSTIFY":"z8pUW"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-3c82dd70.js.map
